import store from "@/store";
import router from "@/router";

export function hasBtnPermission(permission){
    let routerName=router.currentRoute._value.name;
    // console.log(routerName);
    const myPermission =store.getters.getBtnPermissions;
    return myPermission.indexOf(routerName+':'+permission) > -1
}
